import * as React from 'react';

import { TextWithLinkContainer } from './TextWithLink';

interface IPopupWithFormProps {
}

export function PopupWithForm({}: IPopupWithFormProps) {
  return(
    <TextWithLinkContainer />
  );
}
